import { Common } from './Common';
import { Employee } from './Employees';

export class Relative extends Common {

    emp_id: string;
    name: string;
    url: string;
    relation: string;
    relative_id: string;
    showRelative: boolean;
    emp: Employee;
    dob: Date;
    gender: string;
    gotra: string;
    age: number;

    status: string;
    death: Date;
    existing: boolean;
}